<div class="info-group" [ngClass]="size">
    <div class="info-group-header">
        <h4>{{headline}}</h4>
    </div>
    <div class="info-group-body">
        <ng-content select="app-info-group-body"></ng-content>
    </div>
</div>
